import {
  createDatabaseSeenIndicator,
  DatabaseSeenIndicatorOptions,
} from '@repo/utils';
import { API } from 'api';
import { apiBasePath, apiName } from 'assets';
import {
  fromSeenIndicatorDTO,
  SeenIndicatorDTO,
  toSeenIndicatorDTO,
} from 'helpers/newUpdateIndicatorsDTOs';

const upsert: DatabaseSeenIndicatorOptions['upsert'] = async (...indicator) => {
  await API.put(apiName, `${apiBasePath}/seen-indicators`, {
    body: toSeenIndicatorDTO(indicator),
  });
};

const fetchPersisted: DatabaseSeenIndicatorOptions['fetchPersisted'] =
  async () => {
    const { result } = await API.get(
      apiName,
      `${apiBasePath}/seen-indicators`,
      {},
    );
    return (result as SeenIndicatorDTO[]).map(fromSeenIndicatorDTO);
  };

export const seenIndicatorDB = createDatabaseSeenIndicator({
  upsert,
  fetchPersisted,
});
